import { render, staticRenderFns } from "./kiosks.vue?vue&type=template&id=38f5b60f&scoped=true"
import script from "./kiosks.vue?vue&type=script&lang=js"
export * from "./kiosks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f5b60f",
  null
  
)

export default component.exports